import { create } from 'zustand';

const useUiStore = create((set) => ({
  isFormVisible: false,
  showForm: () => set({ isFormVisible: true }),
  hideForm: () => set({ isFormVisible: false }),
}));

export default useUiStore;
